let userData = { loaded: false, isLogged: false };
let submitButton = 'login';

export const formAddRecipe = (formId) => {

    const target = document.getElementById(formId); 
    if (!target) return;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initForm(formId);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.05
    });
    observer.observe(target);
    
}


const getUserStatus = async (url) => {
    //return {"isLogged":false,"name":null,"gotPrize":null,"prizeStock":true,"email":null,"loginUrl":"https:\/\/testext7.wp.pl\/local\/1l\/fake_login?continue_url=https%3A%2F%2Fstatics.teams.cdn.office.net%2F%3Fpost_login%3D1"};
    //return { "isLogged": true, "name": "Iga", "gotPrize": false, "prizeStock": true, "email": "iga_swiatek@na.poczatek.com", "loginUrl": "https:\/\/testext7.wp.pl\/local\/1l\/fake_login?continue_url=https%3A%2F%2Fstatics.teams.cdn.office.net%2F%3Fpost_login%3D1" }
    //jak nie jest zalogowany to dodać loginUrl - przekierowanie do logowania 1Login
    //jeśli jest zalogowany to zwrócić name, email zalogowanego usera do wypenienia formularza konkursowego 
    //loginUrl potrzezbny tylko wtedy, gdy użytkownik jest NIEzalogowany - to adres do 1L czyli tam gdzie się loguje.
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Server responded with status: ${response.status}`);
        }
        return await response.json();
    } catch (err) {
        console.log('Error', err);
        return { isLogged: false, gotPrize: false, prizeStock: false, voted: false, isError: true };
    }
};

const initForm = async (formId) => {

    const FormVoting = document.getElementById(formId);

    //zaczytaj stan usera i logowania z API
    if (userData.loaded === false) {
        if (!FormVoting.dataset.statusUrl) {
            console.error('Brak form status-url!');
            return;
        }
        let o = await getUserStatus(FormVoting.dataset.statusUrl);
        Object.assign(userData, o);
        userData.loaded = true;

        //console.log(userData);

        if (userData.name) {
            FormVoting.name.value = userData.name;
        }

        if (userData.email) {
            FormVoting.email.value = userData.email;
        }
    }

    if (!userData.isLogged) {
        const lightbox = document.getElementById('lightboxLogin');
        lightbox.classList.add('__jsActive');
        lightbox.querySelector('a.button').href = userData.loginUrl;
        return;
    }

    document.querySelector('.form__fake_select__trigger').addEventListener('click', (e) => {
        e.target.classList.toggle('__jsActive');
        e.target.closest('.form__fake_select').classList.toggle('__jsActive');
    });

    //województwa
    document.getElementById('province').addEventListener('focus', (e) => {
        if (document.getElementById('province').value.length <= 1) {
            e.target.classList.add('__jsActive');
            e.target.closest('.form__fake_select').classList.add('__jsActive');
        }
    });

    let provinceInput = document.getElementById('province');
    provinceInput.parentNode.querySelector('.form__fake_select_list ul').addEventListener('click', (e) => {
        document.getElementById('province').value = e.target.dataset.value;
        e.target.parentNode.querySelectorAll('li').forEach(el => {
            if (el == e.target) {
                el.classList.add('__jsActive');
            } else {
                el.classList.remove('__jsActive');
            }
            e.target.closest('.form__fake_select').classList.remove('__jsActive');
        });
    });

    const startSlug = (url => {
        const parseUrl = new URL(url, 'https://wp');
        const segments = parseUrl.pathname.split('/').filter(Boolean);
        return segments[0];
    })(serviceBaseUrl);

    const startProvince = provinceInput.parentNode.querySelector(`.form__fake_select_list ul li[data-value="${startSlug}"]`);
    if (startProvince instanceof Node) {
        startProvince.click();
    }

    //dodanie zdjęcia
    document.getElementById('fileInput').addEventListener("change", e => {

        const randomFileName = function () {
            let d = new Date();
            d = d.toISOString().substring(0, 19).replace(/[:T-]/gi, '');
            return d + "-" + String(Math.random().toString(34).substring(2, 32));
        }

        var fileList = e.target.files;
        if (fileList.length < 1) {
            //nie wybrano pliku
            return;
        } else {
            document.getElementsByClassName('__upload-loader')[0].style.display = 'flex';

            var data = new FormData();
            data.append('contest_id', 121);
            data.append('file', fileList[0], randomFileName());
            
            //weź pierwszy plik i wyślij przez API
            var xhr = new XMLHttpRequest()
            xhr.open('POST', 'https://contests-upload.wp.pl/v2/fu')
            //xhr.setRequestHeader("Content-Type", "multipart/form-data");
            xhr.onload = function () {
                if (xhr.status === 200) { //respondeURL
                    var imageUrl = JSON.parse(xhr.response).url;
                    document.getElementById('imageUrl').value = imageUrl;
                    document.getElementById('fileInput').style.visibility = 'hidden';
                    document.getElementsByClassName('__upload-loader')[0].style.display = 'none';

                    var image = document.createElement('img');
                    image.src = imageUrl;
                    image.setAttribute('id', 'imagePreview');
                    document.getElementsByClassName('__js-gallery')[0].insertBefore(
                        image,
                        document.getElementsByClassName('__js-gallery')[0].firstChild
                    );
                    document.getElementsByClassName('__upload-loader')[0].style.display = 'flex';
                    document.getElementsByClassName('__js-gallery')[0].style.display = 'flex';
                    document.getElementsByClassName('__upload-loader')[0].style.display = 'none';
                }
                else if (xhr.status === 415) {
                    Toastify({
                        text: "Twoje zdjęcie jest zbyt duże lub ma niepoprawny format", duration: 3000, newWindow: true,
                        close: true, gravity: "bottom", stopOnFocus: true
                    }).showToast();
                    document.getElementsByClassName('__upload-loader')[0].style.display = 'none';
                }
                else console.log(xhr.status, xhr.statusText);
            }
            xhr.onerror = () => reject(Error('There was a network error.'))
            xhr.send(data);
        }
    }, false);

    document.getElementById('removeImage').addEventListener('click', e => {
        document.getElementById('imagePreview').remove();
        document.getElementsByClassName('__js-gallery')[0].style.display = 'none';
        document.getElementById('fileInput').style.visibility = 'visible';
        document.getElementById('imageUrl').value = '';
    });

    //submit
    FormVoting.querySelectorAll('input.btn[type=submit]').forEach((el) => {
        el.addEventListener('click', async (e) => {
            submitButton = e.currentTarget.name;
        });
    });

    const url = FormVoting.action;
	if (!url) {
		console.log('Fatal error - no form entry url');
		return;
	}

    FormVoting.addEventListener('submit', async (e) => {
        e.preventDefault();

        valideteForm();

        if (!userData.isLogged && submitButton === 'login') {
            //storage( candidateId );

            if (window.self === window.top) {
                document.location.href = decodeURI(userData.loginUrl);
            } else {
                parent.postMessage({ action: 'login', url: decodeURI(userData.loginUrl) }, "*");
            }
        } else {

            if (Object.keys(errorFields).length === 0) {
                //walidacja bez błedów - wysyłamy
                
                var data = new FormData(FormVoting);
                data.foto = '';
                data.append('form_placement', '');

                let response = await fetch(url, {
                    method: 'POST',
                    body: data
                })
                .then(response => {
                    if (response.status == 200) {
                        return response.text();
                    }
                })
                .then((responseTxt) => {
                    //Komunikat z backendu
                    document.getElementById('boxSuccess').classList.add('__jsActive')
                    setTimeout(()=>{
                        window.scrollTo({
                        top:
                            Math.round(window.scrollY) +
                            Math.round(document.querySelector('#dodajPrzepis').getBoundingClientRect().top) -
                            70,
                        left: 0,
                        behavior: 'smooth',
                        });
                    }, 10);
                })
                .catch((error) => {
                    console.log('error', error)
                });

            }

        }

        return false;
    });

    document.querySelector('#boxSuccess .form__shoutbox_close').addEventListener('click', e => {
       document.location.href = '';
    });



    // WALIDACJA
    const errosMsgs = {
        'name': 'Pole <i>imię</i> jest obowiązkowe',
        'surname': 'Pole <i>nazwisko</i> jest obowiązkowe',
        'province': 'Wybierz proszę swoje <i>województwo</i>',
        'email': 'Podaj poprawny email',
        'phone': 'Pole <i>telefon</i> jest obowiązkowe',
        'street': 'Pole <i>ulica</i> jest obowiązkowe',
        'code': 'Pole <i>kod</i> jest obowiązkowe',
        'city': 'Pole <i>miasto</i> jest obowiązkowe',
        'recipe': 'Wpisz przepis. Możliwie szczegółowo.',
        'zgoda1': 'To pole jest wymagane',
        'zgoda2': 'To pole jest wymagane',
    }

    let errorFields = {};
    const errorMsg = function (fieldNode) {
        const msg = fieldNode.parentNode.querySelector('.__jsErrMsg');
        if (!msg || msg.nodeType !== 1) {
            const msgDiv = document.createElement('div');
            msgDiv.innerHTML = errosMsgs[fieldNode.name];
            msgDiv.classList.add('__jsErrMsg');
            fieldNode.closest('fieldset').appendChild(msgDiv);
        }
    }

    const valideteForm = function () {
        Object.keys(errosMsgs).forEach(key => {
            liveValidation(FormVoting.querySelector(`#${key}`));
        });
    }

    const liveValidation = function (e) {
        let ve;
        if (e instanceof Node) {
            ve = e;
        } else if (e instanceof Event) {
            ve = e.target;
        }

        switch (ve.getAttribute('name')) {
            case 'name':
                if (ve.value.length < 3 || ve.value.length > 120) {
                    errorMsg(ve);
                    ve.parentNode.classList.add('__jsErr');
                    errorFields['imie'] = true;
                } else {
                    ve.parentNode.classList.remove('__jsErr');
                    delete errorFields['name'];
                }
                break;
            case 'surname':
                if (ve.value.length < 3 || ve.value.length > 120) {
                    errorMsg(ve);
                    ve.parentNode.classList.add('__jsErr');
                    errorFields['imie'] = true;
                } else {
                    ve.parentNode.classList.remove('__jsErr');
                    delete errorFields['surname'];
                }
                break;
            case 'province':
                if (ve.value.length < 3) {
                    errorMsg(ve);
                    ve.closest('fieldset').classList.add('__jsErr');
                    errorFields['province'] = true;
                } else {
                    ve.closest('fieldset').classList.remove('__jsErr');
                    delete errorFields['province'];
                }
                break;
            case 'email':
                if (!ve.value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    errorMsg(ve);
                    ve.parentNode.classList.add('__jsErr');
                    errorFields['email'] = true;
                } else {
                    ve.parentNode.classList.remove('__jsErr');
                    delete errorFields['email'];
                }
                break;
            case 'phone':
                if (ve.value.length < 3) {  //numer telefony
                    errorMsg(ve);
                    ve.closest('fieldset').classList.add('__jsErr');
                    errorFields['phone'] = true;
                } else {
                    ve.closest('fieldset').classList.remove('__jsErr');
                    delete errorFields['phone'];
                }
                break;

            case 'street':
                if (ve.value.length < 3) {  
                    errorMsg(ve);
                    ve.closest('fieldset').classList.add('__jsErr');
                    errorFields['street'] = true;
                } else {
                    ve.closest('fieldset').classList.remove('__jsErr');
                    delete errorFields['street'];
                }
                break;
            case 'recipe':
                if (ve.value.length < 10) {
                    errorMsg(ve);
                    ve.parentNode.classList.add('__jsErr');
                    errorFields['recipe'] = true;
                } else {
                    ve.parentNode.classList.remove('__jsErr');
                    delete errorFields['recipe'];
                }
                break;

            case 'zgoda1':
                if (!ve.checked) {
                    errorMsg(ve);
                    ve.closest('fieldset').classList.add('__jsErr');
                    errorFields['zgoda1'] = true;
                } else {
                    ve.closest('fieldset').classList.remove('__jsErr');
                    delete errorFields['zgoda1'];
                }
            case 'zgoda2':
                if (!ve.checked) {
                    errorMsg(ve);
                    ve.closest('fieldset').classList.add('__jsErr');
                    errorFields['zgoda2'] = true;
                } else {
                    ve.closest('fieldset').classList.remove('__jsErr');
                    delete errorFields['zgoda2'];
                }
                break;
        }

    }

    FormVoting.querySelectorAll('input').forEach(el => {
        el.addEventListener("keypress", (event) => {
            liveValidation(event);
        });
        el.addEventListener("change", (event) => {
            liveValidation(event);
        });
        el.addEventListener("keyup", (event) => {
            liveValidation(event);
        });
    });

    FormVoting.querySelector('textarea').addEventListener("change", (event) => {
        liveValidation(event);
    });

    FormVoting.querySelector('textarea').addEventListener("keyup", (event) => {
        var ve = event.target;
        ve.parentNode.classList.remove('__jsErr');
    });

}
